
import { NormalizedArgument } from "@/@types";
import { getAcceptabilityFromProCon, pluralize } from "@/store";
import { computed, defineComponent, PropType, toRefs } from "vue";
import ScoreIcon from "./ScoreIcon.vue";
export default defineComponent({
  props: {
    items: {
      type: Array as PropType<NormalizedArgument[]>,
      required: true,
    },
    alternative: {
      type: Number,
      required: true,
    },
    icon: {
      type: Boolean,
    },
  },

  setup(props) {
    const { items } = toRefs(props);

    return {
      acceptability: computed(() => getAcceptabilityFromProCon(items.value)),

      getAcceptabilityFromProCon,
      pluralize,
    };
  },

  components: {
    ScoreIcon,
  },
  // props: ["items", "alternative", "icon"],
  computed: {},
  methods: {},
});
